import {combineReducers} from 'redux';
import overview from './overview/reducer';
import impressions from './impressions/reducer';
import sessions from './sessions/reducer';
import userengagement from './userengagement/reducer';
import skupreferences from './skupreferences/reducer';

export default combineReducers({
  overview,
  impressions,
  sessions,
  userengagement,
  skupreferences,
});
